import { useState, useEffect, useContext } from 'react';

function LiveReserveMaintenance() {
    return (
        <div className="alert alert-warning">
          只今メンテナンス中です。<br />
          調整まで暫くお待ちください。
        </div>
    );
}

export default LiveReserveMaintenance;